export default __webpack_public_path__ + "static/media/depofenergy.03de22a1.jpg";